<h2 rds-dialog-header>Rename template</h2>
<div rds-dialog-content>
  <div class="row" [formGroup]="form">
    <div class="col mt-9">
      <div class="row">
        <div class="col-12">
          <rds-form-field>
            <rds-control-label>Title of the Template</rds-control-label>
            <input formControlName="title" rdsInput required/>
            <rds-control-hint class="right">{{form.get('title').value?.length || 0}}/100</rds-control-hint>
            <rds-control-error *ngIf="form.get('title').hasError('required') && form.get('title').touched">This field is required</rds-control-error>
            <rds-control-error *ngIf="form.get('title').hasError('maxlength') && form.get('title').touched">Maximum number of characters exceeded</rds-control-error>
            <rds-control-error *ngIf="(form.get('title').hasError('required') || form.get('title').hasError('maxlength')) && form.get('title').touched" class="right">{{form.get('title').value?.length || 0}}/100</rds-control-error>
          </rds-form-field>
        </div>
      </div>
    </div>
  </div>
</div>
<div rds-dialog-actions-container align="end">
    <button
        rds-secondary-button
        [rds-dialog-close]="null"
        size="m"
    >Cancel</button>
    <button
        rds-primary-button
        [disabled]="form.get('title').valid === false"
        [rds-dialog-close]="form.get('title').value"
        size="m"
    >Rename template</button>
</div>